import React, { useEffect } from 'react'

import Header from '../../../components/Arabic/Header/Header'
import UnderHeader from '../../../components/UnderHeader/UnderHeader'
import PageTitle from '../../../components/Arabic/PageTitle/PageTitle'
import Footer from '../../../components/Arabic/Footer/Footer'
import LogoPartner from '../../../components/LogoPartner/LogoPartner'
import Subscribe from '../../../components/Arabic/Subscribe/Subscribe'
import Content from '../../../components/Content/Content'

export default function Steelingot() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])

  return (
    <div>
      <Header page={''} />
      <UnderHeader className={'steelignot'} />
      <PageTitle mainTitle={'سبيكة الصلب'} page={'سبيكة الصلب'} />
      <Content page={'steelIngot'} />
      <Subscribe />
      <LogoPartner />
      <Footer />
    </div>
  )
}
